import React from 'react'
import { useTranslation } from 'react-i18next'

const Footer = () => {
  const{t}=useTranslation()
  return (
    <div className='footer'>
        <div className='container'>
            <div className='all'>
            <div className='footer-content'>
                <ul className='list list-unstyled'>
                    <li>{t('footer.contact')}</li>
                    <li>{t('footer.privacy')}</li>
                    {/* <li>{t('footer.terms')}</li> */}
                    {/* <li>{t('footer.access')}</li>
                    <li>{t('footer.Cookie')}</li> */}
                </ul>
        </div>
        <div className='footer-allRight'>
                <p>{t('footer.rights')}</p>
        </div>
            </div>
        </div>
    </div>
  )
}

export default Footer